import { border, color, rem } from '@thiememeulenhoff/lit-sdk/src';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult, css, unsafeCSS } from 'lit';
import { SCORE_LEVEL_COLOR_MAP } from './score-label.types';

const variant = (label: ScoreLevel, color: CSSResult) => css`
  :host([level='${unsafeCSS(label)}']) {
    background-color: ${color};
  }
`;

export const scoreLabelVariants = Object.keys(SCORE_LEVEL_COLOR_MAP).map(
  (label) =>
    variant(label as ScoreLevel, SCORE_LEVEL_COLOR_MAP[label as ScoreLevel]),
);

export const scoreLabelStyles = [
  ...scoreLabelVariants,
  css`
    :host {
      align-items: center;
      block-size: ${rem(32)};
      border-radius: ${rem(4)};
      display: inline-flex;
      justify-content: center;
      padding: ${rem(8, 16)};
    }

    :host([level]) {
      color: ${color('black')};
    }

    :host(:not([score-type='autoscore'])[level]) {
      background-color: ${color('blue', 500)};
    }

    :host([neutral]) {
      background-color: ${color('grey', 100)};
      border: ${border(1, 'teal', 600)};
      color: ${color('teal', 600)};
    }

    :host([neutral][level]) {
      background: ${color('teal', 600)};
      color: ${color('white')};
    }
  `,
];
